import React from "react";

function AboutUs() {
  return (
    <>
      {/* Hero Banner */}
      <section className="aboutus-hero">
        <div className="aboutus-hero-content">
          <h1>About Kriva Bharat Private Limited</h1>
          <p>Transforming Businesses Through Intelligent Digital Solutions</p>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="aboutus-intro">
        <div className="aboutus-container">
          <div className="intro-content">
            <h2>Who We Are</h2>
            <p>
              Kriva Bharat Private Limited is a forward-thinking IT company focused on 
              developing industry-oriented software platforms tailored to modern business needs.
            </p>
            <p>
              With a strong technical team and domain expertise, we design systems that 
              simplify complex operations, improve transparency, and enhance productivity.
            </p>
            <p>
              Our mission is to deliver reliable, cost-effective, and scalable digital 
              solutions that empower organizations to grow efficiently.
            </p>
          </div>
        </div>
      </section>

      {/* Vision, Mission, Aim Section */}
      <section className="aboutus-vma">
        <div className="aboutus-container">
          <h2>Our Vision, Mission & Aim</h2>
          
          <div className="vma-grid">
            {/* Vision */}
            <div className="vma-card vision-card">
              <div className="vma-icon">🎯</div>
              <h3>Our Vision</h3>
              <p>
                To create a unified digital ecosystem connecting local businesses 
                across India and the world.
              </p>
            </div>

            {/* Mission */}
            <div className="vma-card mission-card">
              <div className="vma-icon">🚀</div>
              <h3>Our Mission</h3>
              <p>
                To digitally connect millions of local businesses and empower them 
                through sustainable connections.
              </p>
            </div>

            {/* Aim */}
            <div className="vma-card aim-card">
              <div className="vma-icon">💡</div>
              <h3>Our Aim</h3>
              <p>
                Every year, over 10 billion business cards are printed worldwide. 
                We aim to replace them with digital connections.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="aboutus-values">
        <div className="aboutus-container">
          <h2>Our Core Values</h2>
          
          <div className="values-grid">
            <div className="value-item">
              <span className="value-icon">💼</span>
              <h4>Innovation</h4>
              <p>Continuously innovating to stay ahead of market trends</p>
            </div>

            <div className="value-item">
              <span className="value-icon">🤝</span>
              <h4>Collaboration</h4>
              <p>Working closely with clients to understand their unique needs</p>
            </div>

            <div className="value-item">
              <span className="value-icon">✅</span>
              <h4>Excellence</h4>
              <p>Delivering high-quality solutions with attention to detail</p>
            </div>

            <div className="value-item">
              <span className="value-icon">🔒</span>
              <h4>Security</h4>
              <p>Ensuring data protection and system reliability at all times</p>
            </div>

            <div className="value-item">
              <span className="value-icon">⚡</span>
              <h4>Efficiency</h4>
              <p>Optimizing processes to deliver maximum value</p>
            </div>

            <div className="value-item">
              <span className="value-icon">🌍</span>
              <h4>Sustainability</h4>
              <p>Building solutions that contribute to long-term growth</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="aboutus-why">
        <div className="aboutus-container">
          <h2>Why Choose Us?</h2>
          
          <div className="why-grid">
            <div className="why-item">
              <h4>Expert Team</h4>
              <p>Highly skilled professionals with years of industry experience</p>
            </div>

            <div className="why-item">
              <h4>Custom Solutions</h4>
              <p>Tailored software solutions for your specific business requirements</p>
            </div>

            <div className="why-item">
              <h4>Scalability</h4>
              <p>Systems designed to grow with your business needs</p>
            </div>

            <div className="why-item">
              <h4>24/7 Support</h4>
              <p>Round-the-clock technical support and maintenance</p>
            </div>

            <div className="why-item">
              <h4>Cost-Effective</h4>
              <p>Affordable solutions without compromising on quality</p>
            </div>

            <div className="why-item">
              <h4>Proven Track Record</h4>
              <p>Successfully implemented solutions across multiple industries</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="aboutus-cta">
        <div className="aboutus-container">
          <h2>Ready to Transform Your Business?</h2>
          <p>Get in touch with our team to discuss your software needs</p>
          <button className="aboutus-cta-btn">Contact Us Today</button>
        </div>
      </section>
    </>
  );
}

export default AboutUs;
